<div class="modal-dialog modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" style="line-height:1.2;">Szűrők beállítása</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">
			<%- include('/ui/form', {
				params: [ 'search_modal', Anvil.page.search ],
				fields: [
					{
						type: 'text',
						name: 'expression',
						title: 'Szöveges keresés',
						attributes: {
							placeholder: 'Keresés...'
						},
						append: '<span class="input-group-text"><i class="fa fa-fw fa-search"></i></span>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'company_group_id',
						title: 'Cég csoport',
						params: {
							maxItems: 1,
							options: [ { id: -1, name: '[ csoporton kívüli ]' }, ...Anvil.page.company_groups.data ],
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'name' ],
							render: {
								item: (item, esc) => `<div>${esc(item.name)}</div>`,
								option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
							},
							placeholder: '[ minden cégcsoport ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.company_group_id = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'invoicing_period',
						title: 'Számlázási periódus',
						params: {
							maxItems: 1,
							options: [
								{ value: 'monthly', label: 'Havi' },
								{ value: 'quarterly', label: 'Negyedéves' },
								{ value: 'half-yearly', label: 'Féléves' },
								{ value: 'annual', label: 'Éves' }
							],
							valueField: 'value',
							labelField: 'label'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.invoicing_period = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					}
				]
			}) %>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async save () {
		/*
		const res = await Anvil.exec('c_order/terminal/action_save', Anvil.page.modal.terminal)
		*/

		// Close modal
		if (res === true) Anvil.page.modal.close()
	}
})
</script>
